/* Package imports */
import axios from 'axios';

/* Utility imports */
import { GlobalValues } from './constants/global';

const axiosInstance = axios.create({
    baseURL: GlobalValues.apiBaseUrl
});

export default axiosInstance;